// MobileSearchModal.jsx
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import darksearch from "../images/darksearch.svg";

export const MobileSearchModal = ({ isOpen, onClose, data }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const navigate = useNavigate();

  // Reset search when modal opens
  useEffect(() => {
    if (isOpen) {
      setSearchTerm("");
      setSearchResults([]);
    }
  }, [isOpen]);

  // Handle search input change
  const handleSearchChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);

    if (term.trim().length > 1) {
      performSearch(term);
    } else {
      setSearchResults([]);
    }
  };

  // Perform search on data
  const performSearch = (term) => {
    if (!data || !term) {
      setSearchResults([]);
      return;
    }

    const results = [];
    const normalizedTerm = term.toLowerCase().trim();

    // Search through the league data structure
    data.forEach((league) => {
      league.titleWrps.forEach((wrap) => {
        wrap.matches.forEach((match) => {
          const team1 = match.team1.toLowerCase();
          const team2 = match.team2.toLowerCase();

          if (
            team1.includes(normalizedTerm) ||
            team2.includes(normalizedTerm)
          ) {
            results.push({
              team1: match.team1,
              team2: match.team2,
              league: league.leagueTitle,
              gameId: match.gameId,
              eventDate: match.eventDate,
            });
          }
        });
      });
    });

    // Limit results to top 10 for better UX
    setSearchResults(results.slice(0, 10));
  };

  // Handle click on search result
  const handleResultClick = (gameId) => {
    // Navigate to match profile page
    navigate(`/match/${gameId}`);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 z-[999] flex items-start justify-center pt-16">
      <div className="bg-forestGreen w-full max-w-md rounded-md overflow-hidden">
        <div className="p-4 border-b border-gray-700 flex items-center">
          <div className="relative flex-1">
            <input
              type="search"
              value={searchTerm}
              onChange={handleSearchChange}
              autoFocus
              className="w-full p-3 pl-10 rounded-md bg-teal shadow-inputshadow text-white"
              placeholder="Search teams..."
            />
            <img
              src={darksearch}
              alt="search"
              className="absolute w-[18px] h-[18px] top-1/2 -translate-y-1/2 left-3 z-50"
            />
          </div>
          <button
            onClick={onClose}
            className="ml-3 text-white hover:text-yellow"
          >
            Cancel
          </button>
        </div>

        <div className="max-h-[70vh] overflow-y-auto">
          {searchResults.length > 0 ? (
            searchResults.map((result, index) => (
              <div
                key={index}
                onClick={() => handleResultClick(result.gameId)}
                className="p-4 hover:bg-shadeGreen cursor-pointer border-b border-gray-700"
              >
                <div className="text-white font-medium">
                  {result.team1} vs {result.team2}
                </div>
                <div className="text-gray-300 text-sm flex justify-between mt-1">
                  <span>{result.league}</span>
                  <span>{result.eventDate}</span>
                </div>
              </div>
            ))
          ) : searchTerm.length > 1 ? (
            <div className="p-4 text-center text-gray-300">No teams found</div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
